import { FnGridColumn } from '../model/fn-grid-column';

export class FnColumnDef extends FnGridColumn {
	override enableChageAcion: boolean = false;
	override enableBlurAcion: boolean = true;
	override enableFocusAcion?: boolean = false;

	constructor(metaData: FnGridColumn, colId?: string) {
		super();
		this.headerName = metaData.headerName;
		this.headerClass = metaData.headerClass;

		this.headerTooltip = metaData.headerTooltip;
		this.colId = metaData.colId || colId;

		this.sortValue = metaData.sortValue;

		this.field = metaData.field;
		this.isFormula = metaData.isFormula;
		this.componentTypeID = metaData.componentTypeID;

		this.componentID = metaData.componentID;
		this.lookupArrayKey = metaData.lookupArrayKey;
		this.lookupIdKeyInRow = metaData.lookupIdKeyInRow;
		this.lookupDescKey = metaData.lookupDescKey;

		this.dataType = metaData.dataType;
		this.isEditDisable = metaData.isEditDisable;
		this.styleClass = metaData.styleClass;
		this.isSortable = metaData.isSortable;
		this.sortCls = metaData.sortCls;
		this.isHidden = metaData.isHidden;
		this.cellClass = metaData.cellClass;
		this.cellClass = metaData.cellClass;
		this.isInlineEditable = metaData.isInlineEditable;
		this.isFilterEnable = metaData.isFilterEnable;

		this.enableChageAcion = metaData.enableChageAcion;
		this.enableBlurAcion = metaData.enableBlurAcion;
		this.enableFocusAcion = metaData.enableFocusAcion;
		this.enableSelectionChangeAcion = metaData.enableSelectionChangeAcion;
		this.enableClickAcion = metaData.enableClickAcion;
		this.enableDbClickAcion = metaData.enableDbClickAcion;
		this.cellStyleFormatting = metaData.cellStyleFormatting;
		this.valueFormatter = metaData.valueFormatter;

		this.width = metaData.width;
		this.autoWidth = metaData.autoWidth;
	}
}
